// extracted by mini-css-extract-plugin
export var awardsPress = "awards-press-module--awardsPress--19oYG";
export var copy = "awards-press-module--copy--2gGaD";
export var title = "awards-press-module--title--2VqSF";
export var listItem = "awards-press-module--listItem--1qguI";
export var arrow = "awards-press-module--arrow--1qrdz";
export var listItemCopy = "awards-press-module--listItemCopy--aTavV";
export var mediaContainer = "awards-press-module--mediaContainer--3IyLM";
export var media = "awards-press-module--media--55ksK";